import React, {Component} from 'react';
import {langService} from "../services/lang.service";


class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      special: {
        title_ka: 'შექმნილია კროკობეთზე',
        title_en: 'Created on Crocobet',
        title_ru: 'Создано на Crocobet',
        filterType: 'special'
      },
      navigation: [
        {
          title_ka: 'ყველა',
          title_en: 'All',
          title_ru: 'Все',
          filterType: 'all'
        },
        {
          title_ka: 'სპორტი',
          title_en: 'Sport',
          title_ru: 'Спорт',
          filterType: 'sports'
        },
        {
          title_ka: 'სლოტი',
          title_en: 'Slots',
          title_ru: 'Слот',
          filterType: 'slots'
        },
        {
          title_ka: 'პოკერი',
          title_en: 'Poker',
          title_ru: 'Poker',
          filterType: 'poker'
        },
        {
          title_ka: 'კაზინო',
          title_en: 'Casino',
          title_ru: 'Казино',
          filterType: 'casino'
        },
        {
          title_ka: 'თამაშები',
          title_en: 'Games',
          title_ru: 'Игры',
          filterType: 'games'
        },
        {
          title_ka: 'სხვა',
          title_en: 'Other',
          title_ru: 'Другие',
          filterType: 'other'
        }
      ],
      filterType: this.props.filterType,
      language: ''
    };

    this.renderLanguage = this.renderLanguage.bind(this);
  }

  componentDidMount() {
    this.langSubscribe = langService.getLang().subscribe(lang => {
      this.setState({
        language: lang.lang
      });
    });
  }

  componentWillUnmount() {
    this.langSubscribe.unsubscribe();
  }

  setFilterType(type) {
    this.props.setFilterType(type);
    this.setState({
      filterType: type
    });
  }

  renderLanguage(obj) {
    const {language} = this.state;
    // console.log('current language is - ', language);

    if (language.toLowerCase() === 'ka') {
      return obj.title_ka;
    } else if (language.toLowerCase() === 'en') {
      return obj.title_en;
    } else {
      return obj.title_ru;
    }
  }



  render() {
    const {navigation, special} = this.state;
    const {filterType} = this.props;

    return (
      <div className="nav-list">
        <ul className="navigation">
          <li className={'list-item list-item--button'}>
            <a
              onClick={() => this.setFilterType('special')}
              href={'#special'}
              className={'button ' + (this.state.filterType === 'special' ? 'button--active' : '')}
            >
              <b>{this.renderLanguage(special)}</b>
            </a>
          </li>
          {navigation.map((obj, key) => {
            return <li
              key={key}
              className={'list-item'}>
              <a onClick={() => this.setFilterType(obj.filterType)}
                 className={'item ' + (filterType === obj.filterType ? 'item--active' : '')}
                 href={"#" + this.state.language + '?=' + obj.filterType}
              >
                {this.renderLanguage(obj)}
              </a>
            </li>
          })}

        </ul>
      </div>
    );
  }

}

export default Navigation;
